/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hemanth Yarlagadda",
  title: "Hello there, I'm Hemanth Yarlagadda",
  subTitle: emoji(
    "A passionate DevOps Engineer 🚀 having an experience of building infra on public clouds like AWS, Azure, GCP with Terraform along with orchestrating kubernetes clusters and some other cool monitoring and alerting frameworks."
  ),
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Hemanth-Yarlagadda",
  linkedin: "https://www.linkedin.com/in/hemanthyarlagadda/",
  email: "yarlaghh@mail.uc.edu",
  medium: "https://medium.com/@yarlaghh",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY DEVOPS ENGINEER WHO WANTS TO EXPLORE RELEVANT TECH STACK",
  skills: [
    emoji(
      "⚡ Design and implement CI/CD pipelines for automated testing, building, and deployment of applications"
    ),
    emoji(
      "⚡ Manage and orchestrate containerized applications using Kubernetes and Docker in cloud environments"
    ),
    emoji(
      "⚡ Implement Infrastructure as Code (IaC) using Terraform and Ansible for automated infrastructure provisioning"
    ),
    emoji(
      "⚡ Set up and maintain monitoring, logging, and alerting systems using tools like Prometheus, Grafana, and ELK stack"
    ),
    emoji(
      "⚡ Implement security best practices and compliance standards in cloud infrastructure and applications saving OPEX and CAPEX"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // This still support from font awesome
    // {
    //   skillName: "html-5",
    //   fontAwesomeClassname: "fab fa-html5"
    // },
    // {
    //   skillName: "html-5",
    //   localIconPath: require("./assets/icons/HTML5.svg")
    // },
    {
      skillName: "argocd",
      localIconPath: require("./assets/icons/argocd.svg").default
    },
    {
      skillName: "k8s",
      localIconPath: require("./assets/icons/k8s.svg").default
    },
    {
      skillName: "helm",
      localIconPath: require("./assets/icons/helm.svg").default
    },
    {
      skillName: "aws",
      localIconPath: require("./assets/icons/aws.svg").default
    },
    {
      skillName: "azure",
      localIconPath: require("./assets/icons/azure.svg").default
    },
    {
      skillName: "azure-devops",
      localIconPath: require("./assets/icons/ad.svg").default
    },
    {
      skillName: "python",
      localIconPath: require("./assets/icons/python.svg").default
    },
    {
      skillName: "bash",
      localIconPath: require("./assets/icons/bash.svg").default
    },
    {
      skillName: "docker",
      localIconPath: require("./assets/icons/docker.svg").default
    },
    {
      skillName: "podman",
      localIconPath: require("./assets/icons/podman.svg").default
    },
    {
      skillName: "rancher",
      localIconPath: require("./assets/icons/rancher.svg").default
    },
    {
      skillName: "terraform",
      localIconPath: require("./assets/icons/tf.svg").default
    },
    {
      skillName: "ansible",
      localIconPath: require("./assets/icons/ansible.svg").default
    },
    {
      skillName: "vagrant",
      localIconPath: require("./assets/icons/vagrant.svg").default
    },
    {
      skillName: "splunk",
      localIconPath: require("./assets/icons/splunk.svg").default
    },
    {
      skillName: "prometheus",
      localIconPath: require("./assets/icons/prometheus.svg").default
    },
    {
      skillName: "grafana",
      localIconPath: require("./assets/icons/grafana.svg").default
    },
    {
      skillName: "jaeger",
      localIconPath: require("./assets/icons/jt.svg").default
    },
    {
      skillName: "kafka",
      localIconPath: require("./assets/icons/kafka.svg").default
    },
    {
      skillName: "mongodb",
      localIconPath: require("./assets/icons/mongoDB.svg").default
    },
    {
      skillName: "jenkins",
      localIconPath: require("./assets/icons/jenkins.svg").default
    },
    {
      skillName: "harness",
      localIconPath: require("./assets/icons/harness.svg").default
    },
    {
      skillName: "datadog",
      localIconPath: require("./assets/icons/datadog.svg").default
    },
    {
      skillName: "linux",
      localIconPath: require("./assets/icons/linux.svg").default
    },
    {
      skillName: "ubuntu",
      localIconPath: require("./assets/icons/ubuntu.svg").default
    },
    {
      skillName: "debian",
      localIconPath: require("./assets/icons/debian.svg").default
    },
    {
      skillName: "maven",
      localIconPath: require("./assets/icons/mvn.svg").default
    },
    {
      skillName: "git",
      localIconPath: require("./assets/icons/git.svg").default
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Cincinnati",
      logo: require("./assets/images/ucLogo.png"),
      subHeader: "Master of Science in Computer Engineering. GPA: 3.67/4.0",
      duration: "August 2018 - Decemeber 2019",
      desc: "Participated in hackathon and stood 4th among various universities."
      //   descBullets: [
      //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      //   ]
    }

    // {
    //   schoolName: "MGIT",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Cloud", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Orchestration",
      progressPercentage: "100%"
    },
    {
      Stack: "Programming",
      progressPercentage: "8  0%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "DevOps Engineer",
      company: "Fiserv",
      companylogo: require("./assets/images/fiservLogo.png"),
      companyLogoWidth: "150",
      companyLogoHeight: "50",
      date: "April 2024 – Present",
      desc: "Working as a DevOps Engineer in Fiserv. I am responsible for the deployment and management of the infrastructure and orchestrating kubernetes clusters.",
      descBullets: [
        " Cut cloud computing costs by 43% by migrating workloads to arm64-based nodes on Amazon EKS, optimizing resource utilization",
        " Designed and implemented full-stack observability for EKS clusters using Grafana and Prometheus, improving system reliability and reducing mean time to detect (MTTD)",
        " Improved container security posture by 67% by proactively identifying and remediating high-risk CVEs in container images, aligning with security compliance standards"
      ]
    },
    {
      role: "DevOps Engineer",
      company: "Chase",
      companylogo: require("./assets/images/chaseLogo.png"),
      companyLogoWidth: "150",
      companyLogoHeight: "50",
      date: "June 2023 – April 2024",
      desc: "Worked as a DevOps Engineer. Responsible for infrastructure provisioning and orchestrating kubernetes clusters on AWS.",
      descBullets: [
        "Automated the deployment of 100+ services on AWS EKS using Terraform and Helm charts, reducing deployment time by 75%",
        "Developed a CI/CD pipeline for a microservice using Jenkins and Docker, reducing build time by 50%"
      ]
    },
    {
      role: "DevOps Engineer",
      company: "AWS",
      companylogo: require("./assets/images/awsLogo.png"),
      companyLogoWidth: "150",
      companyLogoHeight: "50",
      date: "Sept 2022 – April 2023",
      desc: "Worked as part of AWS Professional Services. I was responsible to ease the migration of workloads to AWS EKS and provide best practices for the same."
    },
    {
      role: "DevOps Engineer",
      company: "Rockwell Automation",
      companylogo: require("./assets/images/raLogo.svg"),
      companyLogoWidth: "150",
      companyLogoHeight: "50",
      date: "Aug 2021 – Sep 2022",
      desc: "Worked as a DevOps Engineer. Responsible for maintaining the vmware vsphere environment and migrating on premise workloads to Azure public cloud."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/meditech.png"),
      projectName: "MediTechSafe",
      projectDesc: "Helped create network traffic analyzer for medical devices",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.meditechsafe.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    // {
    //   image: require("./assets/images/nextuLogo.webp"),
    //   projectName: "Nextu",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://nextu.se/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji(" Certifications 🏆 "),
  subtitle:
    "Tech certs that I have obtained so far",

  achievementsCards: [
    {
      title: "AWS Certified Solutions Architect Associate",
      subtitle:
        "",
      image: require("./assets/images/awssaLogo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/c48c6158-fb07-4a18-bd73-099607105509/public_url"
        },
      ]
    },
    {
      title: "Terraform Associate (003)",
      subtitle:
        "",
      image: require("./assets/images/tfcertLogo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/ccef04e6-f907-47aa-8876-a1a5830616ba/public_url"
        },
      ]
    },
    {
      title: "AWS Certified Developer Associate",
      subtitle:
        "",
      image: require("./assets/images/awsdevLogo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/261e7f3e-9ef4-4cdf-a720-77c0f900b52a/public_url"
        },
      ]
    },
    {
      title: "Microsoft Certified Azure Fundamentals",
      subtitle:
        "",
      image: require("./assets/images/azureLogo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/375bbec0-66f6-4771-b1cc-612d6b4bcf45/public_url"
        },
      ]
    }
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With passion for developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    // {
    //   url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
    //   title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
    //   description:
    //     "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    // },
    {
      url: "https://medium.com/@yarlaghh/deploying-3-tier-architecture-using-terraform-on-aws-part-1-b383ad7d56b",
      title: "Deploying a 3 tier architecture using Terraform on AWS",
      description:
        "Terraform is best used for provisioning and managing cloud infrastructure, supporting multi-cloud deployments, automating environment provisioning, detecting and remediating infrastructure drift, enabling collaboration and version control, and promoting modular and reusable infrastructure code"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section
const podcastSection = {
  title: emoji("YouTube"),
  subtitle: "I'm passionate about sharing my story and exploring technology",

  // Function to display YouTube video within HTML
  renderYouTubeVideo: function (url) {
    return `<iframe width="100%" height="500" src="${url}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  },

  // Please Provide with your youtube embeded Link
  podcast: [
    "https://www.youtube.com/embed/fL3C7ik_s-8",
    // "https://www.youtube.com/embed/another_video_id" // Add another video here
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "yarlaghh@mail.uc.edu"
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  podcastSection,
  contactInfo,
  isHireable
};
